import React, { useState } from 'react';

import { images } from '../../constants';

import { client } from '../../client';
import './Footer.css';

const Footer = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = () => {
    setLoading(true);

    const contact = {
      _type: 'contact',
      name: formData.username,
      email: formData.email,
      message: formData.message,
    };

    client.create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className='footer-container' id='contact'>
      <h2>
        Logic is the foundation of the certainty of all the knowledge we acquire.<br></br><span> - Leonhard Euler</span>
      </h2>

      <div className='contact-link'>
        <div>
          <img width='25px' src={images.email} alt="email" />
          <a href="mailto:rounakpaul@hotmail.com">rounakpaul@hotmail.com</a>
        </div>
        <div>
          <img width='25px' src={images.mobile} alt="phone" />
          <a href="tel:+91 8609637424">+91 8609637424</a>
        </div>
      </div>
      {!isFormSubmitted ? (
        <div className='form-container'>
          <div>
            <input type="text" placeholder="Your Name" name="username" value={username} onChange={handleChangeInput} />
          </div>
          <div>
            <input type="email" placeholder="Your Email" name="email" value={email} onChange={handleChangeInput} />
          </div>
          <div>
            <textarea
              
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
          <button type="button" onClick={handleSubmit}>{!loading ? 'Send Message' : 'Sending...'}</button>
        </div>
      ) : (
        <div>
          <h3 className='form-after-text'>
            Thank you for getting in touch!
          </h3>
        </div>
      )}
      <div className='footer-img'>
        <img src={images.earth} alt='footer-img'/>
      </div>
    </div>
  );
};

export default Footer